module.exports = __webpack_public_path__ + "img/nav.cf80e7bb.png";